module.exports = __webpack_public_path__ + "static/img/image@2x (6).3a5cc46a.png";